import './index.scss'
import 'swiper/css';
import React, { useRef } from 'react'
import ArrowButton from '../ArrowButton'
import { Swiper, SwiperSlide } from 'swiper/react';
import useSlider from '../../hooks/useSlider';

const ImageSlider = ({ images }) => {
  const swiperRef = useRef(null);
  const { onInit, isEnd, isBeginning, nextSlide, prevSlide, handleDrag } = useSlider(swiperRef);

  const options = {
    freeMode: false,
    centeredSlides: true,
    spaceBetween: 50,
  };

  return (
    <div className="image-slider">
      <Swiper {...options} onBeforeInit={onInit} onSlideChange={handleDrag}>
        {images.map((image, index) => (
          <SwiperSlide key={index} virtualIndex={index}>
            <div style={{ textAlign: 'center' }}>
              <img
                src={image.image}
                style={{ margin: 'auto' }}
                alt={image.alt}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="image-slider__bottom">
        <div className="image-slider__button-wrapper">
          <ArrowButton
            onClick={prevSlide}
            mods={isBeginning ? ['left', 'disable'] : ['left']}
          />
          <ArrowButton
            onClick={nextSlide}
            mods={isEnd ? ['right', 'disable'] : ['right']}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageSlider
